import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import EditDocumentUtils from "utils/EditDocument";
import Files from "utils/Files";
import IntegrationServices from "const/IntegrationServices";
import MainApiActions from "actions/MainApiActions";
import Preloader from "nlib/common/Preloader";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Texts from "utils/Texts";
import UiActions from "actions/UiActions";
import classNames from "classnames";

const DocumentPreview = (props) => {
  const {
    error,
    children,
    className,
    hasAttachment,
    documentPreview,
    previewPageMeta: { angle } = {},
    onClick
  } = props;

  const { uiTexts } = useSelector(getTextsData);

  const dispatch = useDispatch();

  const { extraData: { integrationService } } = useSelector(getSelectedBusinessData);

  const [imageSrc, setImageSrc] = useState(null);

  const [imageLoaded, setImageLoaded] = useState(false);

  const imageStyle = useMemo(() => {
    return { transform: `rotate(${EditDocumentUtils.normalizeAngle(angle)}deg)` };
  }, [angle]);

  const { logo: serviceLogo, label: serviceName } = IntegrationServices.getByValue(integrationService);

  const fetchData = useCallback(async() => {
    setImageLoaded(false);
    setImageSrc(null);

    const response = await dispatch(MainApiActions.fetchAttachmentUrl(documentPreview, false, true));

    setImageSrc(response);
    await Files.preloadImages([response]);
    setImageLoaded(true);

    return response;
  }, [dispatch, documentPreview]);

  const handlePreviewClick = useCallback(async() => {
    if (!imageSrc) return;
    if (onClick) {
      onClick();

      return;
    }
    dispatch(UiActions.showModalImages([""]));
    try {
      await Files.preloadImages([imageSrc]);
      dispatch(UiActions.showModalImages([imageSrc]));
    } catch (errorB) {
      const response = await fetchData();

      dispatch(UiActions.showModalImages([response]));
    }
  }, [dispatch, imageSrc, fetchData, onClick]);

  useEffect(() => {
    if (imageSrc || !documentPreview) return;
    fetchData();
  }, [imageSrc, documentPreview, fetchData]);

  return (
    <div className={classNames(Css.documentPreview, className)}>
      <div className={Css.container}>
        {imageSrc && (
          <div className={Css.image} onClick={handlePreviewClick}>
            <img src={imageSrc} style={imageStyle} />
            <div className={Css.icon}>
              <Icons.ArrowsOut />
            </div>
          </div>
        )}
        {hasAttachment
          ? (error
            ? (!documentPreview || !imageLoaded) && (
              <Preloader absolute className={Css.preloader} />
            )
            : (!documentPreview && (
              <Icons.FileX className={Css.error} />
            )))
          : (
            <div className={Css.dummyFile}>
              <img src={serviceLogo} />
              <Icons.File weight="thin" className={Css.dummyIcon} />
              <div className={Css.dummyText}>
                {Texts.replaceVars(uiTexts.documentImportedFrom, { serviceName })}
              </div>
            </div>
          )}
      </div>
      {children}
    </div>
  );
};

export default React.memo(DocumentPreview);
